export type ImportWarning = "MISSING_FUND_SIZE" | "UNDRAWN_RECONCILIATION_MISMATCH" | "TVPI_RECONCILIATION_MISMATCH";

export const ImportWarning = {
    MISSING_FUND_SIZE: "MISSING_FUND_SIZE" as ImportWarning,
    UNDRAWN_RECONCILIATION_MISMATCH: "UNDRAWN_RECONCILIATION_MISMATCH" as ImportWarning,
    TVPI_RECONCILIATION_MISMATCH: "TVPI_RECONCILIATION_MISMATCH" as ImportWarning,
};

export interface ImportResult {
    generalPartnerId?: number;
    fundId?: number;
    fundReportId?: number;
    dataset?: string;
    assetIds?: number[];
    fundInvestmentIds?: number[];
    warnings?: ImportWarning[];
}
